<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  // components: {
  //   Main
  // },
  mounted() {
    console.log(document.location.host)
    //* ****************************解决刷新页面数据丢失开始**************************************** */
    // if (sessionStorage.getItem("store")) {
    //   this.$store.replaceState(
    //     Object.assign(
    //       {},
    //       this.$store.state,
    //       JSON.parse(sessionStorage.getItem("store"))
    //     )
    //   );
    //   sessionStorage.removeItem("store");
    // }

    // //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload", () => {
    //   sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    // });
  }
}
</script>
<style>
@import '../static/css/iconfont.css';
</style>
<style lang="scss">
@import "../static/css/sidebar.scss";
@import "./style/gloable.scss";
@import "./style/style.scss";

</style>
<style>

</style>




// WEBPACK FOOTER //
// src/App.vue